<section class="page-container">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <h1 class="main-heading">Master Colour List</h1>
    <app-navpath />
  </div>
  <div class="mb-2 flex w-full flex-wrap items-end gap-1 md:w-fit">
    <button class="shorter-btn misc-btn" (click)="addEntry()">
      <fa-icon [icon]="faPlus" class="mr-1"></fa-icon>Add
    </button>
    <button
      class="shorter-btn delete-btn"
      (click)="onDeleteClick()"
    >
      <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>Delete
    </button>
    <app-search-input
      (dataOutput)="onSearch($event)"
      [isTable]="true"
    ></app-search-input>
  </div>
  <div class="content-container">
    <app-data-table
      [tableHeaders]="tableHeaders"
      [tableEntries]="filteredData"
      (open)="openEntry($event)"
    ></app-data-table>
  </div>
</section>
